var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"habit-description"},[_c('explanation',{attrs:{"caption":"詳細","description":"習慣の詳細を設定します。"}}),_c('input-description'),_c('button-set-description')],1)}
var staticRenderFns = []

export { render, staticRenderFns }